export enum EnumDeviceType {
    NAVIGATOR = 2,
    CORDOVA = 3,
    CORDOVA_POS = 4
}